import React from "react"
import { useTranslation } from "react-i18next"

import { Checkbox } from "components"
import classes from "./OsfAccessOnly.module.scss"

const OsfUserOnly = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const handleIsViewed = (checked) => {
    setForm(prev => ({
      ...prev, addedBySystem: checked ? false : null
    }))
  }

  return (
    <div className={classes["checkbox-container"]}>
      <div className={classes["checkbox"]}>
        {t("سفارشات_سایت")}
      </div>

      <Checkbox
        checked={form.addedBySystem === false}
        onChange={handleIsViewed}
      />
    </div>
  )
}

export default OsfUserOnly